import { Model, Attr } from 'spraypaint';

import { ApplicationRecord } from './application_record';

@Model()
export default class Permission extends ApplicationRecord {
  static jsonapiType = 'permissions';
  @Attr() name: string;
}
